import { render, staticRenderFns } from "./routing.vue?vue&type=template&id=5b724db0&"
import script from "./routing.vue?vue&type=script&lang=js&"
export * from "./routing.vue?vue&type=script&lang=js&"
import style0 from "./routing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports